module.exports = __webpack_public_path__ + "img/Formacao_de_Equipes.20b3a706.jpeg";